/**
 * Check if a user has admin access
 * Admins have full access to policy management features
 *
 * @param user - User object from auth context
 * @returns true if user is admin, false otherwise
 */ export function isAdmin(user) {
    if (!user || !user.role) {
        return false;
    }
    return user.role.toLowerCase() === 'admin';
}
/**
 * Get admin status display message
 *
 * @param user - User object from auth context
 * @returns User-friendly message about admin status
 */ export function getAdminStatusMessage(user) {
    if (isAdmin(user)) {
        return 'You have administrator access to policy management';
    }
    return 'Read-only access - Administrator privileges required for policy editing';
}
